export default "__VITE_ASSET__Cia4qc$5__"